var map = {
	"./about-card.de-CH.json": 1528,
	"./about-card.de-DE.json": 1529,
	"./about-card.en-CA.json": 1530,
	"./about-card.en-GB.json": 1531,
	"./about-card.en-IN.json": 1532,
	"./about-card.en-ME.json": 1533,
	"./about-card.en-US.json": 1534,
	"./about-card.es-EM.json": 1535,
	"./about-card.es-ES.json": 1536,
	"./about-card.fr-BE.json": 1537,
	"./about-card.fr-CA.json": 1538,
	"./about-card.fr-CH.json": 1539,
	"./about-card.nl-BE.json": 1540,
	"./about-card.nl-NL.json": 1541,
	"./about-card.pl-PL.json": 1542,
	"./about-card.pt-BR.json": 1543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1527;